import React from "react";
import { string, bool } from "prop-types";

import { processHtmlLinks } from "../../../utils/html-utils";
import "./rich-text.m.css";

const RichText = ({ content, isMobile = false, ...props }) => {
  const styleClass = isMobile ? "rich-text-mobile" : "rich-text";
  const htmlContent = content || '';

  return (
    <div styleName={styleClass} {...props} dangerouslySetInnerHTML={{ __html: processHtmlLinks(htmlContent) }} />
  );
};

RichText.propTypes = {
  content: string,
  isMobile: bool
};

export default RichText;